import { FunctionComponent, useMemo } from 'react';
import { IInstitution, ITrial, ISourceDataConfigurationSummary } from '@/api/dtos';
import { ListItemButton, ListItemText, Chip, Box, LinearProgress, styled } from '@mui/material'
import { Link } from 'react-router-dom';
import Highlight, { IMatchedSubstring } from '@/components/layouts/Highlight';
import Fuse from 'fuse.js';


const LabelContainer = styled('div')({
    display: 'flex'
});

interface IConfigurationSummaryListItem {
    trial?: ITrial;
    summary?: ISourceDataConfigurationSummary;
    linkFn?: (trial?: ITrial, summary?: ISourceDataConfigurationSummary) => string;
}

const ConfigurationSummaryListItem: FunctionComponent<IConfigurationSummaryListItem> = ({
    summary,
    trial,
    linkFn
}) => {

    return (
        <ListItemButton component={Link} to={linkFn?.(trial, summary) ?? `/${trial?.code}/configurations/${summary?.id}`}>
            <ListItemText
                primary={
                    <LabelContainer>
                            {summary?.name}
                    </LabelContainer>
                }
                secondary={summary?.description}
            />
        </ListItemButton>
    );
}

export default ConfigurationSummaryListItem;